import { Alert, Button } from '@components'
import { RadioGroup, RadioItem } from '@components/OnboardingRadioList'
import {
  SlideContent,
  SlideFooter,
  SlideText,
  SlideTitle,
  Spacer
} from '@pages/BankIntegrationOnboardingPage/slides/slide.styled'
import React, { useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { FaArrowRight } from 'react-icons/fa'

interface Props {
  onHasBankAccount: () => void
  onHasNoBankAccount: () => void
  onSkip: () => void
}

export const EnsureBankAccountSlide: React.FC<Props> = ({
  onHasBankAccount,
  onHasNoBankAccount,
  onSkip
}) => {
  const { t } = useTranslation()
  const [hasBankAccount, setHasBankAccount] = useState<boolean>(true)

  return (
    <>
      <SlideContent>
        <SlideTitle>{t('bankOnboarding.start.title')}</SlideTitle>

        <SlideText>
          <Alert
            type="info"
            description={
              <>
                <p>{t('bankOnboarding.start.description')}</p>
                <p style={{ marginBottom: 0 }}>
                  <Trans i18nKey="bankOnboarding.start.description2">
                    <a
                      href={t('bankOnboarding.start.description2Link')}
                      target="_blank"
                      rel="noreferrer"
                    />
                  </Trans>
                </p>
              </>
            }
          />
        </SlideText>
        <br />
        <SlideText>
          <p>
            <b>{t('bankOnboarding.start.questionTitle')}</b>
          </p>

          <RadioGroup>
            <RadioItem
              key="yes"
              selected={hasBankAccount === true}
              onSelect={() => setHasBankAccount(true)}
              value={true}
              label={t('general.yes')}
            />
            <RadioItem
              key="no"
              selected={hasBankAccount === false}
              onSelect={() => setHasBankAccount(false)}
              value={false}
              label={t('general.no')}
            />
          </RadioGroup>
        </SlideText>
        <Spacer />
      </SlideContent>
      <SlideFooter>
        <Button
          intent="default"
          isSecondary
          onClick={() => onSkip()}
          data-test="skip-ensure-bank-account-button"
        >
          {t('general.skip')}
        </Button>
        <Spacer />
        <Button
          intent={'primary'}
          disabled={hasBankAccount === null}
          iconRight={<FaArrowRight />}
          onClick={() => {
            hasBankAccount ? onHasBankAccount() : onHasNoBankAccount()
          }}
        >
          {t('general.next')}
        </Button>
      </SlideFooter>
    </>
  )
}
